/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root',
})
export class AppService {
   authenticated = false;

   constructor() {}

   getUrl() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.socialBasePort ;
      return url;
  }

  getUrlNotifications() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.socialNotificationPort ;
      return url;
  }

   getUrlStatistics() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.statisticsAppPort;
      return url;
   }
   
   getDocManagerUrl() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.documentManagerPort;
      return url;
   }

   getCpsuUrl() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.cpsuPort;
      return url;
   }

   getAccountingReportUrl() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.accountingReportPort;
      return url;
   }

   getServiceProvidersUrl() {
      let url: string;
      url = window.location.protocol + '//' + window.location.hostname + environment.serviceProvidersPort;
      return url;
   }
}
